import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { LuDatetimePickerModule } from 'lu-datetime-picker';
import { FromAbstractToFormControlPipe } from 'lu-from-abstract-to-form-control-pipe';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { LuDatetimeFormlyPickerComponent } from './lu-datetime-formly-picker.component';

const declarations = [LuDatetimeFormlyPickerComponent];

const imports = [
	CommonModule,
	ReactiveFormsModule,
	LuDatetimePickerModule,
	BsDatepickerModule.forRoot(),
	TimepickerModule.forRoot(),
	PopoverModule,
	FromAbstractToFormControlPipe,
	FormlyModule.forChild({
		types: [
			{
				name: 'datetime',
				component: LuDatetimeFormlyPickerComponent,
				wrappers: ['form-field']
			}
		]
	})
];

@NgModule({
	imports,
	declarations
})
export class LuDatetimeFormlyPickerModule {}
